import { InformationCircleIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { uniqueId } from "lodash";
import { ReactNode } from "react";
import { Tooltip } from "react-tooltip";
import { isDeviceMobile } from "utils/helpers";

function HintIconWithTooltip({
  hintText,
  hintTextClassName,
  direction,
  isInfo = false,
  elementClassName = "",
}: {
  hintText: ReactNode;
  hintTextClassName?: String;
  direction: "bottom" | "left" | "top" | "right";
  isInfo?: boolean;
  elementClassName?: string;
}) {
  const isMobile = isDeviceMobile();
  const uniqueClassName = uniqueId("tooltip_");
  return (
    <span className={clsx("text-white", elementClassName)}>
      {isInfo ? (
        <InformationCircleIcon
          className={`${uniqueClassName} ml-1 inline-block h-5 w-5 cursor-pointer transition-transform hover:scale-110`}
        />
      ) : (
        <QuestionMarkCircleIcon
          className={`${uniqueClassName} ml-1 inline-block h-5 w-5 cursor-pointer transition-transform hover:scale-110`}
        />
      )}
      <Tooltip
        positionStrategy="fixed"
        openOnClick={isMobile}
        anchorSelect={`.${uniqueClassName}`}
        variant="dark"
        place={direction}
        style={{ opacity: 1, zIndex: 100 }}
      >
        <div className={` ${hintTextClassName}`}>{hintText}</div>
      </Tooltip>
    </span>
  );
}
export default HintIconWithTooltip;
